// Backend activity name that grants access to QuotesV2.
// Access is resolved through the Activities service (see UsersService.isUserAllowedQuotesV2).
export const QUOTES_V2_ACCESS_ACTIVITY = "quoter_v2_access";

// Agreement codes whose users get direct QuotesV2 access without requiring the activity.
export const QUOTES_V2_DIRECT_ACCESS_AGREEMENT_CODES = ["suzuki_santander"];

export function createQuoteWithSitingState(application: any, use_initial_request?: boolean): any {
  let quote;

  if (use_initial_request === undefined) {
    if (Object.keys(application.approved_request || {}).length == 0) {
      quote = application.initial_request || {};
    } else {
      quote = application.approved_request || {};
    }
  } else {
    quote = use_initial_request ? application.initial_request || {} : application.approved_request || {};
  }

  if (application.siting_state_id) {
    quote.siting_state_id = application.siting_state_id;
  }

  return quote;
}
